/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from './XHR'
import { DocIdentifier } from '../model/DocIdentifier'
import { RelatedPerson } from '../model/RelatedPerson'
import { ListOfIds } from '../model/ListOfIds'
import { AuthenticationProvider, NoAuthenticationProvider } from '../../icc-x-api/auth/AuthenticationProvider'
import { iccRestApiPath } from './IccRestApiPath'
import { EntityBulkShareResult } from '../model/requests/EntityBulkShareResult'
import { FilterChainRelatedPerson } from '../model/FilterChainRelatedPerson'
import { PaginatedListRelatedPerson } from '../model/PaginatedListRelatedPerson'
import { AbstractFilterRelatedPerson } from '../model/AbstractFilterRelatedPerson'
import { TimingInfo } from '../model/TimingInfo'
import { BulkShareOrUpdateMetadataParams } from '../model/requests/BulkShareOrUpdateMetadataParams'
import { ConflictResolutionRequest } from '../model/ConflictResolutionRequest'
import { ConflictResolutionResult } from '../model/ConflictResolutionResult'
import { ConflictResolutionStrategy } from '../model/ConflictResolutionStrategy'
import { MergeResult } from '../model/MergeResult'

export class IccRelatedPersonApi {
  host: string
  _headers: Array<XHR.Header>
  authenticationProvider: AuthenticationProvider
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  get headers(): Promise<Array<XHR.Header>> {
    return Promise.resolve(this._headers)
  }

  constructor(
    host: string,
    headers: any,
    authenticationProvider?: AuthenticationProvider,
    fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>
  ) {
    this.host = iccRestApiPath(host)
    this._headers = Object.keys(headers).map((k) => new XHR.Header(k, headers[k]))
    this.authenticationProvider = !!authenticationProvider ? authenticationProvider : new NoAuthenticationProvider()
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this._headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }

  /**
   *
   * @summary Gets a related person
   * @param relatedPersonId
   */
  async getRelatedPerson(relatedPersonId: string): Promise<RelatedPerson> {
    const _body = null

    const _url = this.host + `/relatedperson/${encodeURIComponent(String(relatedPersonId))}` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new RelatedPerson(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * @summary Get a list of related persons by ids
   * @param body
   */
  async getRelatedPersons(body: ListOfIds): Promise<Array<RelatedPerson>> {
    const _url = this.host + `/relatedperson/byIds` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new RelatedPerson(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns an instance of created related person.
   * @summary Create a related person
   * @param body
   */
  async createRelatedPerson(body: RelatedPerson): Promise<RelatedPerson> {
    const _url = this.host + `/relatedperson` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new RelatedPerson(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the instances of the created related persons.
   * @summary Create a batch of related persons
   * @param body
   */
  async createRelatedPersons(body: Array<RelatedPerson>): Promise<Array<RelatedPerson>> {
    const _url = this.host + `/relatedperson/batch` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new RelatedPerson(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the modified related person.
   * @summary Modify a related person
   * @param body
   */
  async modifyRelatedPerson(body: RelatedPerson): Promise<RelatedPerson> {
    const _url = this.host + `/relatedperson` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new RelatedPerson(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the modified related persons.
   * @summary Modify a batch of related persons
   * @param body
   */
  async modifyRelatedPersons(body: Array<RelatedPerson>): Promise<Array<RelatedPerson>> {
    const _url = this.host + `/relatedperson/batch` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new RelatedPerson(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @summary Deletes a related person by id.
   *
   * @param relatedPersonId the id of the related person to delete
   * @return a Promise that will resolve in the DocIdentifier of the deleted related person.
   */
  async deleteRelatedPerson(relatedPersonId: string): Promise<DocIdentifier> {
    const _url = this.host + `/relatedperson/${encodeURIComponent(relatedPersonId)}` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('DELETE', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new DocIdentifier(doc.body))
      .catch((err) => this.handleError(err))
  }

  /**
   * Response is a set containing the ID's of deleted related persons.
   * @summary Delete related persons.
   * @param body
   */
  async deleteRelatedPersons(body: ListOfIds): Promise<Array<DocIdentifier>> {
    const _url = this.host + `/relatedperson/delete/batch` + '?ts=' + new Date().getTime()
    const headers = (await this.headers).filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new DocIdentifier(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @internal this method is for internal use only and may be changed without notice
   */
  async bulkShareRelatedPersons(request: BulkShareOrUpdateMetadataParams): Promise<EntityBulkShareResult<RelatedPerson>[]> {
    const _url = this.host + '/relatedperson/bulkSharedMetadataUpdate' + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, request, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((x) => new EntityBulkShareResult<RelatedPerson>(x, RelatedPerson)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns a list of related persons along with next start keys and Document ID. If the nextStartKey is Null it means that this is the last page.
   * @summary List related persons for the current user (HcParty) or the given data owner in the filter
   * @param body
   * @param startDocumentId A related person document ID
   * @param limit Number of rows
   * @param collectTiming if true, include server-side filter timing information in the response
   */
  filterRelatedPersonsBy(
    body: FilterChainRelatedPerson,
    startDocumentId?: string,
    limit?: number,
    collectTiming?: false
  ): Promise<PaginatedListRelatedPerson>
  filterRelatedPersonsBy(
    body: FilterChainRelatedPerson,
    startDocumentId?: string,
    limit?: number,
    collectTiming?: true
  ): Promise<PaginatedListRelatedPerson & TimingInfo>
  async filterRelatedPersonsBy(
    body: FilterChainRelatedPerson,
    startDocumentId?: string,
    limit?: number,
    collectTiming: boolean = false
  ): Promise<PaginatedListRelatedPerson> {
    const _url =
      this.host +
      `/relatedperson/filter` +
      '?ts=' +
      new Date().getTime() +
      (startDocumentId ? '&startDocumentId=' + encodeURIComponent(String(startDocumentId)) : '') +
      (limit ? '&limit=' + encodeURIComponent(String(limit)) : '')
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand(
      'POST',
      _url,
      headers,
      body,
      this.fetchImpl,
      undefined,
      this.authenticationProvider.getAuthService(),
      undefined,
      false,
      collectTiming ? ['x-filter-timing-*'] : []
    )
      .then((doc) => Object.assign(new PaginatedListRelatedPerson(doc.body as JSON), collectTiming ? { responseHeaders: doc.responseHeaders } : {}))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Get ids of related persons matching the provided filter for the current user (HcParty)
   * @param body
   * @param collectTiming if true, include server-side filter timing information in the response
   */
  matchRelatedPersonsBy(body: AbstractFilterRelatedPerson, collectTiming?: false): Promise<Array<string>>
  matchRelatedPersonsBy(body: AbstractFilterRelatedPerson, collectTiming?: true): Promise<Array<string> & TimingInfo>
  async matchRelatedPersonsBy(body: AbstractFilterRelatedPerson, collectTiming: boolean = false): Promise<Array<string>> {
    const _url = this.host + `/relatedperson/match` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand(
      'POST',
      _url,
      headers,
      body,
      this.fetchImpl,
      undefined,
      this.authenticationProvider.getAuthService(),
      undefined,
      false,
      collectTiming ? ['x-filter-timing-*'] : []
    )
      .then((doc) =>
        Object.assign(
          (doc.body as Array<JSON>).map((it) => JSON.parse(JSON.stringify(it))),
          collectTiming ? { responseHeaders: doc.responseHeaders } : {}
        )
      )
      .catch((err) => this.handleError(err))
  }

  /**
   * Retrieves the ids of all the related persons that currently have conflicting revisions and therefore need to
   * be resolved.
   * @summary List the ids of the related persons that have conflicts.
   * @return the ids of the related persons with unresolved conflicts.
   */
  async getConflictingEntitiesIds(): Promise<Array<string>> {
    const _url = this.host + `/relatedperson/conflicts` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body as Array<string>)
      .catch((err) => this.handleError(err))
  }

  /**
   * Retrieves all the conflicting revisions of the related person with the given id (the current revision is not
   * included). The returned entities are still encrypted.
   * @summary Get the conflicting revisions of a related person.
   * @param entityId the id of the related person to retrieve the conflicts for.
   * @return the conflicting revisions of the related person.
   */
  async getConflictsForEntity(entityId: string): Promise<Array<RelatedPerson>> {
    const _url = this.host + `/relatedperson/conflicts/of?entityId=${encodeURIComponent(String(entityId))}` + '&ts=' + new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new RelatedPerson(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Resolves a conflict by declaring which revision of the related person should be kept as winner and which
   * conflicting revisions should be purged. The provided document must already be encrypted.
   * @summary Declare the winning revision of a conflicting related person.
   * @param body the {@link ConflictResolutionRequest} carrying the winning revision and the conflicts to purge.
   * @return the {@link ConflictResolutionResult} with the saved winner and the conflicts that are still unresolved.
   */
  async declareConflictWinner(body: ConflictResolutionRequest<RelatedPerson>): Promise<ConflictResolutionResult<RelatedPerson>> {
    const _url = this.host + `/relatedperson/conflicts/winner` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new ConflictResolutionResult<RelatedPerson>(doc.body, (x) => new RelatedPerson(x)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link getConflictingEntitiesIds} but targets the entities of the group with the given id.
   * @summary List the ids of the related persons that have conflicts, in the given group.
   * @param groupId the id of the group to look into.
   * @return the ids of the related persons with unresolved conflicts in the group.
   */
  async getConflictingEntitiesIdsInGroup(groupId: string): Promise<Array<string>> {
    const _url = this.host + `/relatedperson/inGroup/${encodeURIComponent(String(groupId))}/conflicts` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body as Array<string>)
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link getConflictsForEntity} but targets the entity of the group with the given id.
   * @summary Get the conflicting revisions of a related person, in the given group.
   * @param groupId the id of the group the related person belongs to.
   * @param entityId the id of the related person to retrieve the conflicts for.
   * @return the conflicting revisions of the related person.
   */
  async getConflictsForEntityInGroup(groupId: string, entityId: string): Promise<Array<RelatedPerson>> {
    const _url =
      this.host +
      `/relatedperson/inGroup/${encodeURIComponent(String(groupId))}/conflicts/of?entityId=${encodeURIComponent(String(entityId))}` +
      '&ts=' +
      new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new RelatedPerson(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link declareConflictWinner} but targets the entity of the group with the given id.
   * @summary Declare the winning revision of a conflicting related person, in the given group.
   * @param groupId the id of the group the related person belongs to.
   * @param body the {@link ConflictResolutionRequest} carrying the winning revision and the conflicts to purge.
   * @return the {@link ConflictResolutionResult} with the saved winner and the conflicts that are still unresolved.
   */
  async declareConflictWinnerInGroup(
    groupId: string,
    body: ConflictResolutionRequest<RelatedPerson>
  ): Promise<ConflictResolutionResult<RelatedPerson>> {
    const _url = this.host + `/relatedperson/inGroup/${encodeURIComponent(String(groupId))}/conflicts/winner` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new ConflictResolutionResult<RelatedPerson>(doc.body, (x) => new RelatedPerson(x)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Automatically resolves the conflicting revisions of the related persons with the given ids, according to the provided
   * {@link ConflictResolutionStrategy}.
   * @summary Automatically solve the conflicts of the related persons with the given ids.
   * @param entityIds the ids of the related persons to solve the conflicts for.
   * @param strategy the {@link ConflictResolutionStrategy} to use to resolve the conflicts. Defaults to `FullMergeability`.
   * @return the {@link MergeResult} of the conflict resolution for each requested entity.
   */
  async autoSolveConflicts(
    entityIds: Array<string>,
    strategy: ConflictResolutionStrategy = ConflictResolutionStrategy.FullMergeability
  ): Promise<Array<MergeResult>> {
    const _url = this.host + `/relatedperson/conflicts/solve?strategy=${encodeURIComponent(String(strategy))}` + '&ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, entityIds, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new MergeResult(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link autoSolveConflicts} but targets the entities of the group with the given id.
   * @summary Automatically solve the conflicts of the related persons with the given ids, in the given group.
   * @param groupId the id of the group to look into.
   * @param entityIds the ids of the related persons to solve the conflicts for.
   * @param strategy the {@link ConflictResolutionStrategy} to use to resolve the conflicts. Defaults to `FullMergeability`.
   * @return the {@link MergeResult} of the conflict resolution for each requested entity.
   */
  async autoSolveConflictsInGroup(
    groupId: string,
    entityIds: Array<string>,
    strategy: ConflictResolutionStrategy = ConflictResolutionStrategy.FullMergeability
  ): Promise<Array<MergeResult>> {
    const _url =
      this.host +
      `/relatedperson/inGroup/${encodeURIComponent(String(groupId))}/conflicts/solve?strategy=${encodeURIComponent(String(strategy))}` +
      '&ts=' +
      new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, entityIds, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new MergeResult(it)))
      .catch((err) => this.handleError(err))
  }
}
